import React from 'react';
import BannerSection from '../../components/BannerSection';
import Navbar from '../../components/Navbar';

const Shop = () => {
    return (
        <div>
            <Navbar />
            <BannerSection />


            <section id="featured-products" class="pt-120 pb-120">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-8 d-flex align-items-center">
                            <div class="section-header text-center">
                                <h2 class="title">Featured Products</h2>
                                <p>Our goal is to deliver high quality gaming apparel and help grow the gaming community!</p>
                            </div>
                        </div>
                    </div>
                    <div class="row cus-m">
                        <div class="col-lg-4 col-md-6">
                            <div class="single-item">
                                <div class="img-area text-center">
                                    <img src="images/featured-products-1.png" alt="image" />
                                </div>
                                <div class="bottom-item text-center">
                                    <a href="shop-details.html"><h6>Revolution Unlimited Pro Controller</h6></a>
                                    <p class="text-sm">PC / Atmos / Headset</p>
                                    <div class="review">
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star-half-alt"></i></a>
                                        <span class="text-sm">4.3 (79)</span>
                                    </div>
                                    <div class="bottom-area d-flex align-items-center justify-content-between">
                                        <h5>€149.90</h5>
                                        <a href="#" class="cmn-btn">Add to Basket</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="single-item">
                                <span class="new">New</span>
                                <div class="img-area text-center">
                                    <img src="images/featured-products-2.png" alt="image" />
                                </div>
                                <div class="bottom-item text-center">
                                    <a href="shop-details.html"><h6>ST-200 Streaming Microphone</h6></a>
                                    <p class="text-sm">PC / Atmos / Headset</p>
                                    <div class="review">
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star-half-alt"></i></a>
                                        <span class="text-sm">4.3 (79)</span>
                                    </div>
                                    <div class="bottom-area d-flex align-items-center justify-content-between">
                                        <h5>€79.90</h5>
                                        <a href="#" class="cmn-btn">Add to Basket</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <div class="single-item">
                                <div class="img-area text-center">
                                    <img src="images/featured-products-3.png" alt="image" />
                                </div>
                                <div class="bottom-item text-center">
                                    <a href="shop-details.html"><h6>PCCH-350 Playstation Gaming Chair</h6></a>
                                    <p class="text-sm">PC / Atmos / Headset</p>
                                    <div class="review">
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star-half-alt"></i></a>
                                        <span class="text-sm">4.3 (79)</span>
                                    </div>
                                    <div class="bottom-area d-flex align-items-center justify-content-between">
                                        <h5>€159.90</h5>
                                        <a href="#" class="cmn-btn">Add to Basket</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section id="deal-of-day" class="pb-120">
                <div class="overlay pt-120">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-7 d-flex align-items-center">
                                <div class="section-header text-center">
                                    <h2 class="title">Deal of the day</h2>
                                    <p>Visit Game Universe to download new games, pre-order forthcoming titles, or check the latest deals and offers.</p>
                                </div>
                            </div>
                        </div>
                        <div class="main-content">
                            <span class="offer">Special offer</span>
                            <div class="row">
                                <div class="col-lg-6 d-flex align-items-center justify-content-center">
                                    <div class="deal-item">
                                        <div class="img-area text-center">
                                            <img src="images/deal-content.png" alt="image" />
                                        </div>
                                        <div class="draw-counter d-flex">
                                            <div class="head">
                                                <div class="date-area d-flex justify-content-center"
                                                    data-countdown="2022/06/20">
                                                </div>
                                                <div class="time-parameter">
                                                    <span>DAY</span>
                                                    <span>HRS</span>
                                                    <span>MIN</span>
                                                    <span>SEC</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="right-item">
                                        <h4>Revolution Pro Controller</h4>
                                        <p>Comfort, precision and customisation: all of NACON's expertise
                                            has gone into the REVOLUTION Pro Controller 2 for PS4™.
                                            Includes full software, headset jack and a 3m USB-C cable.</p>
                                        <div class="review">
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star"></i></a>
                                            <a href="#"><i class="fas fa-star-half-alt"></i></a>
                                            <span class="text-sm">4.3 (79)</span>
                                        </div>
                                        <div class="prize">
                                            <p>€129.90</p>
                                            <span class="text-sm">As low as</span>
                                        </div>
                                        <div class="bottom-area d-flex align-items-center">
                                            <h5>€79.90</h5>
                                            <a href="#" class="cmn-btn">Add to Basket</a>
                                            <a href="#" class="cmn-btn cus-style">View product</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="policy-section" class="pb-120">
                <div class="container">
                    <div class="main-content">
                        <div class="row cus-m">
                            <div class="col-lg-3 col-md-6">
                                <div class="single-box text-center">
                                    <div class="img-area text-center">
                                        <img src="images/policy-icon-1.png" alt="image" />
                                    </div>
                                    <h5>Free Shipping</h5>
                                    <p class="text-sm">on all orders over $149.00</p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="single-box text-center">
                                    <div class="img-area text-center">
                                        <img src="images/policy-icon-2.png" alt="image" />
                                    </div>
                                    <h5>30 Days returns</h5>
                                    <p class="text-sm">Moneyback guarantee</p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="single-box text-center">
                                    <div class="img-area text-center">
                                        <img src="images/policy-icon-3.png" alt="image" />
                                    </div>
                                    <h5>Secure checkout</h5>
                                    <p class="text-sm">100% Protectted </p>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-6">
                                <div class="single-box text-center">
                                    <div class="img-area text-center">
                                        <img src="images/policy-icon-4.png" alt="image" />
                                    </div>
                                    <h5>Save Money</h5>
                                    <p class="text-sm">Save 10% money</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <footer id="footer-section">
                <div class="overlay">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="footer-top">
                                    <div class="row justify-content-center">
                                        <div class="col-lg-6 col-md-8">
                                            <div class="top-area text-center">
                                                <h3>Subscribe to Our Newsletter</h3>
                                                <p>Receive news, stay updated and special offers</p>
                                            </div>
                                            <form action="#">
                                                <div class="subscribe d-flex">
                                                    <input type="email" placeholder="Your Email Address" />
                                                    <button class="cmn-btn">Subscribe</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-mid pt-120">
                    <div class="container">
                        <div class="row d-flex">
                            <div class="col-lg-8 col-md-8 d-flex justify-content-md-between justify-content-center align-items-center cus-grid">
                                <div class="logo-section">
                                    <a class="site-logo site-title" href="index.html"><img src="images/logo.png" alt="site-logo" /></a>
                                </div>
                                <ul class="menu-side d-flex align-items-center">
                                    <li><a href="index.html" class="active">Home</a></li>
                                    <li><a href="about-us.html">About Us</a></li>
                                    <li><a href="contact.html">Contact</a></li>
                                </ul>
                            </div>
                            <div class="col-lg-4 col-md-4 d-flex align-items-center justify-content-center justify-content-md-end">
                                <div class="right-area">
                                    <ul class="d-flex">
                                        <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                        <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                        <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="container">
                        <div class="main-content">
                            <div class="row d-flex align-items-center justify-content-center">
                                <div class="col-lg-12 col-md-6">
                                    <div class="left-area text-center">
                                        <p>Copyright © 2021. All Rights Reserved By
                                            <a href="#">BEGAM</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default Shop;